import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetUserEmail($id: ID!) {
    chat(id: $id) {
      id
      user {
        id
        email
      }
    }
  }
`);
